'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var definitions = require('../definitions-0c162dc8.js');
var lib = require('../lib-26f8f706.js');
var styleInject_es = require('../style-inject.es-71b52b81.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css_248z = ".Floater {\n  display: flex;\n}\n\n.Floater--positioning-absolute {\n  position: absolute;\n}\n\n.Floater--positioning-fixed {\n  position: fixed;\n}\n\n.Floater--horizontal-align-start-outside {\n  right: 100%;\n}\n\n.Floater--horizontal-align-start {\n  left: 0;\n}\n\n.Floater--horizontal-align-center {\n  left: 50%;\n}\n\n.Floater--horizontal-align-end {\n  right: 0;\n}\n\n.Floater--horizontal-align-end-outside {\n  left: 100%;\n}\n\n.Floater--vertical-align-start-outside {\n  bottom: 100%;\n}\n\n.Floater--vertical-align-start {\n  top: 0;\n}\n\n.Floater--vertical-align-center {\n  top: 50%;\n}\n\n.Floater--vertical-align-end {\n  bottom: 0;\n}\n\n.Floater--vertical-align-end-outside {\n  top: 100%;\n}\n\n.Floater--horizontal-align-center {\n  transform: translate(-50%, 0%);\n}\n\n.Floater--vertical-align-center {\n  transform: translate(0%, -50%);\n}\n\n.Floater--horizontal-align-center.Floater--vertical-align-center {\n  transform: translate(-50%, -50%);\n}\n";
styleInject_es.styleInject(css_248z);

exports.Positioning = void 0;
(function (Positioning) {
    Positioning["Absolute"] = "absolute";
    Positioning["Fixed"] = "fixed";
    Positioning["Sticky"] = "sticky";
})(exports.Positioning || (exports.Positioning = {}));
exports.Alignment = void 0;
(function (Alignment) {
    Alignment["StartOutside"] = "start-outside";
    Alignment["Start"] = "start";
    Alignment["Center"] = "center";
    Alignment["End"] = "end";
    Alignment["EndOutside"] = "end-outside";
})(exports.Alignment || (exports.Alignment = {}));
/** Layout component that positions its child as a floating element,
 * i.e. an element that does not affect the layout of its siblings. */
function Floater(_a) {
    var _b = _a.container, container = _b === void 0 ? 'div' : _b, _c = _a.positioning, positioning = _c === void 0 ? exports.Positioning.Absolute : _c, _d = _a.horizontalAlign, horizontalAlign = _d === void 0 ? exports.Alignment.Start : _d, _e = _a.verticalAlign, verticalAlign = _e === void 0 ? exports.Alignment.Start : _e, _f = _a.offsetX, offsetX = _f === void 0 ? 0 : _f, _g = _a.offsetY, offsetY = _g === void 0 ? 0 : _g, _h = _a.offsetUnit, offsetUnit = _h === void 0 ? definitions.LengthUnit.Rem : _h, zIndex = _a.zIndex, children = _a.children, containerProps = _a.containerProps, className = _a.className, variant = _a.variant;
    var props = { className: className, variant: variant };
    var style = React.useMemo(function () { return (tslib.__assign(tslib.__assign({}, ((offsetX || offsetY) && {
        transform: "translate(" + offsetX + offsetUnit + ", " + offsetY + offsetUnit + ")",
    })), (zIndex !== undefined && { zIndex: zIndex }))); }, [offsetX, offsetY, offsetUnit, zIndex]);
    var Container = container;
    return (React__default["default"].createElement(Container, tslib.__assign({}, containerProps, { style: style, className: lib.classNames('Floater', props, "Floater--positioning-" + positioning, "Floater--horizontal-align-" + horizontalAlign, "Floater--vertical-align-" + verticalAlign) }), children));
}

exports.Floater = Floater;
//# sourceMappingURL=index.js.map
